

import { Injectable } from "@angular/core";
import { MapperInterface } from "@app/shared/mapper/mapper-inteface";
import { TipoIstanzaFascicoloVO } from "../vo/tipo-istanza-fascicoloVO";
import { TipoIstanzaFascicoloDTO } from "../dto/tipo-istanza-fascicoloDTO";



@Injectable({
    providedIn: 'root'
})
export class MapperTipoIstanzaFascicolo implements MapperInterface<TipoIstanzaFascicoloDTO, TipoIstanzaFascicoloVO> {

    convertVoToDto(vo: TipoIstanzaFascicoloVO): TipoIstanzaFascicoloDTO {
        if (vo != null) {
            const dto = new TipoIstanzaFascicoloDTO();
            // ATTENZIONE!! fare mapper questa riga funge solo se DTO e VO sono identici
            dto.codice = vo.codice;
            dto.id = vo.id
            dto.nome = vo.nome;
            return dto;
        } else {
            return null;
        }
    }

    convertDtoToVo(dto: TipoIstanzaFascicoloDTO): TipoIstanzaFascicoloVO {
        if (dto != null) {
            const vo = new TipoIstanzaFascicoloVO();
            // TODO fare mapper questa riga funge solo se DTO e VO sono identici
            // vo = JSON.parse(JSON.stringify(dto));
            vo.codice = dto.codice;
            vo.nome = dto.nome;
            vo.id = dto.id;
            vo.output = dto.codice + " - " + dto.nome;
            return vo;
        } else {
            return null;
        }
    }

    convertListVoToDto(voList: TipoIstanzaFascicoloVO[]): TipoIstanzaFascicoloDTO[] {
        if (voList != null) {
            return voList.map(vo => this.convertVoToDto(vo));
        } else {
            return null;
        }
    }

    convertListDtoToVo(dtoList: TipoIstanzaFascicoloDTO[]): TipoIstanzaFascicoloVO[] {
        if (dtoList != null) {
            return dtoList.map(dto => this.convertDtoToVo(dto));
        } else {
            return null;
        }
    }
}
